import { UserDataService } from './../data-services/user-data.service';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ChangeEmailService {
  constructor(
    private http: HttpClient,
    private userDataService: UserDataService
  ) {}

  updateAccountEmail(email, token, reqBody) {
    return this.userDataService.$userData.pipe(
      map((userData) => {
        const url = `${
          environment.backend_server_url_account
        }/change-email?email=${email}&name=${
          userData.userDetails.firstName || ''
        }`;
        return this.http.put(url, reqBody);
      })
    );
  }
  updateAccountEmailDuringPolicyAdd(userDetails, reqBody) {
    const url = `${environment.backend_server_url_account}/change-email?email=${
      userDetails.email.address
    }&name=${userDetails.firstName || ''}`;
    return this.http.put(url, reqBody);
  }
}
